import { gql } from '@apollo/client'

export const NOTIFICATION_UPDATE_READ_MUTATION = gql`
  mutation($input: UpdateNotificationRecipientInput!) {
    updateNotificationRecipient(input: $input)
  }
`
